<template>
  <div class="rounded-md bg-red-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <!-- <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" /> -->
        <component :is="icons.XCircleIcon" class="h-5 w-5 text-red-400" aria-hidden="true" ></component>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">{{error}}</h3>
        <!-- <div class="mt-2 text-sm text-red-700">
          <ul role="list" class="list-disc space-y-1 pl-5">
            <li>Your password must be at least 8 characters</li>
            <li>Your password must include at least one pro wrestling finishing move</li>
          </ul> 
       </div> -->
      </div>
    </div>
  </div>
</template>





<script>
import { ref, reactive } from 'vue';
// import { XCircleIcon } from '@heroicons/vue/outline';
import { XCircleIcon } from "@heroicons/vue/24/solid"


export default {
  props: ["error"],

  setup(props) {

    const icons = reactive({
      XCircleIcon: XCircleIcon,

    })

    const error = ref("");
    error.value = props.error;

    return { error, icons };
  },
};
</script>
